import { render, staticRenderFns } from "./ConnectorSettingsSidebar.vue?vue&type=template&id=0d976967&scoped=true"
import script from "./ConnectorSettingsSidebar.vue?vue&type=script&lang=js"
export * from "./ConnectorSettingsSidebar.vue?vue&type=script&lang=js"
import style0 from "./ConnectorSettingsSidebar.vue?vue&type=style&index=0&id=0d976967&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d976967",
  null
  
)

export default component.exports